<template>
  <div class="home container">

    <div class="lunbo">
      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="(image, index) in whellList" :key="index">
          <a @click="goxq(image.webUrlId)">
            <img :src="image.webUrl" width="100%" height="100%" />
          </a>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="yy"></div>
    <div class="yy"></div>
    <div class="gongg">
      <div
        class="gonggitem"
        v-for="(value, index) in sylist"
        :key="index"
        v-show="!(value.name == '维修资金' && !showweixiu)"
        @click="changeview(value.to)"
      >
        <img :src="value.icon" alt="" />
        <span>{{ value.name }}</span>
      </div>
    </div>

    <div style="height: 50px"></div>
    <div class="logout" @click="logout">
      <img :src="logoutIcon" alt="" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Grid, GridItem, NoticeBar } from "vant";
import { Dialog } from "vant";
import axios from "axios"
// 导入SM4加密工具
// import { sm4ECBEncrypt } from "../utils/sm4Util"

Vue.use(Grid);
Vue.use(GridItem);
Vue.use(NoticeBar);
import { mapState, mapMutations } from "vuex";
export default {
  inject: ["reload"],
  data() {
    return {
      showPicker: false,
      sm: false,
      pwd: process.env.VUE_APP_DEFAULT_PASSWORD,
      type: 'zhwy',
      lunbolist: [],
      whellList: [],
      sqkbList: [],
      sylist: [],
      xqmc: "",
      currhouse: {},
      issyx: false,
      isYouke: false,
      showweixiu: false, //是否显示维修资金
      shiyunxing: [
        "金色家园",
        "新新家园",
        "印象99花园",
        "东方花园",
        "景尚佳园",
        "众大上海城",
        "润景苑",
        "锦华御园",
        "恒峰御江山",
        "帝景豪苑",
        "朝晖公寓",
        "中豪国际星城",
        "海天翡翠城",
        "幸福学府",
        "丽景湾华庭",
        "乐府兰庭",
        "中远现代城",
        "金田湖畔春天",
        "公园一号",
        "恒昌阳光里",
        "华润景城",
        "金鹰花园",
        "水木清华三期",
        "中港雅典城",
        "丽都水岸花园",
        "新城玺樾府",
        "瀚林国际花园",
        "隆城颐和",
        "隆城紫竹苑",
        "凤凰美地",
        "嘉汇枫景御景园",
        "格林上郡",
        "康堡小区",
        "帝景蓝湾花园",
        "银河花园",
        "恒力水木清华",
        "阳光美地",
        "山水云房",
        "依水佳苑",
        "	嘉盛龙庭国际",
        "海棠樾花园",
        "学府人家",
        "七彩新城",
        "海纳名人雅苑",
        "夏阳银湖花园",
        "鸿润盛景",
        "中德度假村",
        "运河天玺",
        "九里人家",
        "运河雅苑",
        "运河澜湾",
        "兰亭御城",
        "太湖花园",
        "世纪紫薇苑",
        "君悦国际花园",
        "逸品尚居",
        "洋河上郡",
        "盛世景园",
        "明州嘉园",
        "文馨苑",
      ],
      moduleList: [
        {
          icon: require("../assets/icon/wyjj.png"),
          name: "小区概况",
          to: "/wyfw/xqgk_menu",
        },
        {
          icon: require("../assets/dj.png"),
          name: "党建引领",
          to: "/djindex",
        },
        {
          icon: require("../assets/icon/ts.png"),
          name: "投诉建议",
          to: "/tsindex?type=ts",
        },
        {
          icon: require("../assets/icon/xqgg.png"),
          name: "小区公告",
          to: "/common/list/xqgs",
        },
        {
          icon: require("../assets/icon/wyqy.png"),
          name: "物业企业",
          to: "/wyqy",
        },
        {
          icon: require("../assets/icon/wyfw.png"),
          name: "物业服务",
          to: "/wyfw",
        },
        {
          icon: require("../assets/icon/tsbx.png"),
          name: "报事报修",
          to: "/tsbx?type=bx",
        },
        {
          icon: require("../assets/icon/wxzj.png"),
          name: "维修资金",
          to: "/wxzj",
        },
        {
          icon: require("../assets/icon/gzz.png"),
          name: "执法工作站",
          to: "/zhzfz",
        },
        {
          icon: require("../assets/icon/bmfw.png"),
          name: "便民服务",
          to: "/bmfw",
        },
        {
          icon: require("../assets/kao.png"),
          name: "考勤打卡",
          to: "/kaoqin",
        },
        {
          icon: require("../assets/icon/djf.png"),
          name: "物业代缴费",
          to: "/wydjf",
        },
        {
          icon: require("../assets/icon/jf.png"),
          name: "公共收益代缴费",
          to: "/ggsy",
        },
        {
          icon: require("../assets/newicon/rfcwdh.png"),
          name: "人防工程导航",
          to: "rfgcdh",
        },
        {
          icon: require("../assets/newicon/rfcwgl.png"),
          name: "人防车位管理",
          to: "rfcwgl",
        }
      ],
      logoutIcon: require("../assets/icon/logout.png")
    };
  },
  props: {
    refreshobj: String,
  },
  computed: {
    ...mapState(["userInfo", "identity", "houseId", "isactive"]),
    chooseindex() {
      return this.userInfo.houses.findIndex((obj) => obj.isDefault);
    },

  },
  mounted() {
    if (localStorage.getItem("userId")) {
      this.getlunbo();
      // this.getsqkb();
      this.gethomeitems();
    } else {
      this.$router.push({ path: "/home" });
    }
  },

  methods: {
    gethomeitems() {
      this.sylist = [];

      var syname=[
            "小区概况",
            "报事报修",
            // "物业企业",
            "投诉建议",
            "考勤打卡",
            "物业代缴费",
            '公共收益代缴费'
          ];
          // if (localStorage.getItem("yhm") === "测试小区") {
            // syname = [
            //   "报事报修",
            //   "投诉建议",
            //   "考勤打卡",
            //   "物业代缴费",
            //   '公共收益代缴费',
            //   '人防工程导航',
            //   '人防车位管理'
            // ]
          // }
          console.log('111', this.userInfo)
      // this.sylist = this.moduleList.filter(item=> syname.forEach(item1=> item.name == item1))
      syname.forEach((item) => {
        this.moduleList.forEach((a) => {
          if (a.name == item) this.sylist.push(a);
        });
      });
    },
    goxq(id) {
      //  this.$toast.fail('根据市防疫指挥部要求，为确保市区疫情防控静态管控需要，物资需求统计暂缓录入')
      // this.$router.push({path:'/wuzinew'})
    },

    getsqkb() {
      this.$axios
        .get("/api/v1/wygl/notice/list", {
          params: {
            houseId: this.houseId || "1504057892783919106",
            pageNum: 0,
            pageSize: 5,
          },
        })
        .then((res) => {
          this.sqkbList = [...res.data].slice(0, 4);
          this.sqkbList.forEach((item) => {
            item.publishDate = item.publishDate.substring(0, 10);
          });
        });
    },
    getlunbo() {
      this.$axios
        .get("/api/v1/wygl/ownersHomePage/viewlist", {
          params: {
            pageNum: 0,
            pageSize: 10,
          },
        })
        .then((result) => {
          this.whellList = result.data;
        });
    },
    ...mapMutations([
      "changeIdentity",
      "changeUserinfo",
      "changeHouseId",
      "emitactive",
    ]),
    onConfirm(value, index) {
      this.showPicker = false;
      if (index != this.chooseindex) {
        this.$axios
          .get("/api/v2/wechat/user/changeDefaultHouse", {
            params: {
              houseId: value.value,
            },
          })
          .then((res) => {
            this.currhouse = res.houses.filter((item) => {
              return item.isDefault;
            })[0];
            this.changeUserinfo(res);
            this.reload();
          });
      }
    },
    changeview(path, id) {
      if (this.identity != 2 && path == "/yzjc") {
        Dialog.alert({
          message: "您还不是房主，请先去认证房主！",
        }).then(() => {});
        return;
      }
      if (sessionStorage.getItem("isYouke")) {

        if(sessionStorage.getItem('nowType')!=='qiye'){
          if(path=='/tsbx?type=bx'||path=='/tsindex?type=ts'||path=='/wxzj'){
            this.$router.push({ path: "/smrz" });
            return;
          }
        }
      }
      if (path == "/wxzj" && this.issyx) {
        this.$router.push({ path: path, query: { type: "syx" } });
      } else if (path == "rfgcdh") {
        location.href = "https://zhwy.zjj.suqian.gov.cn/manage/#/mobile/map";
      } else if (path == "rfcwgl") {
        location.href = "https://zhwy.zjj.suqian.gov.cn/manage/#/mobile/parking";
        // 使用SM4加密密码
        // const encryptedPassword = sm4ECBEncrypt('68d4832dcf68d558', this.pwd); // 使用16字节密钥
        // const encryptedUsername = sm4ECBEncrypt('68d4832dcf68d558', localStorage.getItem('yhm') || '');
        // const userData = {
        //   username: encryptedUsername,
        //   password: encryptedPassword, // 使用加密后的密码
        //   type: this.type
        // }
        // axios.post('https://zhwy.zjj.suqian.gov.cn/manage/system/singleSignOn/login', userData)
        // .then(response => {
        //   if (response.data.code == 0) {
        //     location.href = `https://zhwy.zjj.suqian.gov.cn/manage/jwt/api/callback?token=${response.data.token}` 
        //   } else {
        //     this.$toast.fail('登录失败，请稍后再试')
        //     return
        //   }
        // })
        // this.$axios
        // .get("/getRfToken", {
        //   params: {
        //     userName: localStorage.getItem('yhm') || ''
        //   },
        // })
        // .then((res) => {
        //   this.$toast.fail('登录失败，请稍后再试' + JSON.stringify(res))
        //   // location.href = `https://zhwy.zjj.suqian.gov.cn/manage/jwt/api/callback?token=${res.data.token}` 
        // });
      } else {
        this.$router.push({
          path,
          query: {
            id,
          },
        });
      }
    },
    logout() {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("userId")
      sessionStorage.setItem('nowType', 'yezhu')//设置下当前用户类型
      this.$router.push({path:'/wuye'})
    }
  },
};
</script>

<style lang="less" scoped>
/deep/.van-notice-bar .van-notice-bar__content {
  width: 100%;
}
.xx {
  width: 100%;
  padding: 10px;
  .xxtitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #00b5ff;
    .gd {
      img {
        height: 10px;
      }
      span {
        font-size: 12px;
        margin-right: 5px;
      }
    }
    .titlename {
      height: 20px;
      display: flex;
      align-items: center;
      .line {
        height: 23px;
        width: 4px;
        border-radius: 2px;
        background-color: #00b5ff;
      }
      span {
        margin-left: 10px;
      }
    }
  }
  .tzcontent {
    height: calc(100% - 25px);
    display: flex;
    align-items: center;
    flex-direction: column;
    .xxitem {
      height: 40px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      .isbold {
        font-weight: bold;
      }
      .new {
        height: 15px;
        width: 15px;
        background-color: #ff455b;
        display: inline-block;
        padding: 0 2px;
        text-align: center;
        vertical-align: middle;
        font-style: normal;
        color: #fff;
        overflow: hidden;
        line-height: 15px;
        font-size: 11px;
        border-radius: 4px;
        font-weight: 200;
        position: absolute;
        left: -17px;
      }
      .reddot {
        color: red;
        position: absolute;
        top: 2px;
        font-size: 30px;
      }
      .tztitle {
        width: 70%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #333333;

        font-size: 15px;
      }
      .tzdate {
        font-size: 13px;
        color: #999999;
      }
    }
  }
}
.location {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 5px 15px;
  background-color: #f1f1f1;

  .fwinfo {
    flex: 1;
    padding-left: 5px;
  }

  .qiehuan {
    font-size: 13px;
    color: #01b4ff;
  }
}
.gdstyle {
  color: #000;
}
.home {
  background-color: #fff;
  height: 100vh;
  position: relative;
  .logout{
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 38px;
    height: 38px;
    background-color: #DA292F;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    img{
      width: 20px;
      height: 20px;
    }
    &:hover{
      background-color: #FF455B;
      img{
        width: 22px;
        height: 22px;
      }
    }
  }
}
.smalltitle {
  height: 35px;
  color: #666666;
}
.flexcenter {
  display: flex;
  justify-content: center;
  align-items: center;
}

.notice-swipe {
  height: 40px;
  line-height: 40px;
}

.djyd {
  height: calc(100% - 35px);
  width: 100%;
  align-items: center;
  .sh1,
  .sh2 {
    display: flex;
    flex-direction: column;
    height: 75%;
    justify-content: center;
    padding-left: 10px;
    // align-items: center;
    // .flexcenter();
  }
}

/deep/.nav .van-grid-item__text {
  font-size: 14px;
}

.sqkb {
  margin-top: 20px;
}

.lunbo {
  // margin-bottom: 5px;
  height: 24%;
  padding: 10px 10px 10px 10px;
  .van-swipe {
    height: 100%;
    /deep/ .van-swipe-item {
      height: auto;
    }
  }
}

.gongg {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  background-color: white;
  .gonggitem {
    height: 100px;
    width: 33%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    // margin-left: 2%;
    img {
      height: 50%;
      width: 40%;
    }
    span {
      font-size: 15px;
      color: #666666;
      margin-top: 5px;
    }
  }
  .gonggitem:not(:nth-child(3n)) {
    // margin-right: 2%;
  }
}

.yy {
  width: 100%;
  height: 6px;
  background-color: rgb(244, 244, 244);
}

.sh1 {
  background: url("../assets/icon/shengh2.png") no-repeat;
  background-size: 100% 100%;
}

.qwe {
  color: white;
  /* margin-left: -85px;
		margin-top: -20px;
		width: 85px; */
}

.qwe1 {
  // width: 30px;
  font-size: 12px;
  margin-top: 3px;
  /*
		margin-left: -77px; */
  color: white;
}

.sh2 {
  background: url("../assets/icon/shengh1.png") no-repeat;
  background-size: 100% 100%;
}

.van-notice-bar {
  background-color: #fff;
  padding: 0;

  .kb {
    width: 40px;
    text-align: center;
    line-height: 18px;
    color: #00b5ff;
    border: #00b5ff 2px solid;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 500;
    margin-right: 8px;
  }

  .van-swipe-item {
    width: 230px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.van-col--11 {
  width: 48%;
}

.div1 {
  width: 100%;
  height: 1px;
  margin-top: 20px;
  background-color: rgb(233, 229, 229);
}

.van-grid-item__content::after {
  border-width: 0;
  display: none;
}

.van-hairline--top {
  border: 0px solid white !important;
}

.van-swipe__indicators {
  display: none;
}

.padd {
  padding: 0 15px;
}
</style>
